











import Vue from 'vue';

export default Vue.extend({
  name: '',
  props: {
    tabs: Array,
    mode: String,
  },
  data() {
    return {
    }
  },
  methods: {
    changeMode(key: string) {
      this.$emit('current', key)
    },
  }
})
